import React from "react";
import Resource from "../Resource";
import { getDescriptionStyle } from "../utilities";
import Content from "./Content";

export interface DescriptionProps {
  isFirstRecentPostItem: boolean;
  isDesktopWidth: boolean;
  isTwoLines: boolean;
  resource: Resource;
}

const Description = ({
  isFirstRecentPostItem,
  isDesktopWidth,
  isTwoLines,
  resource,
}: DescriptionProps) => {
  return (
    <Content
      className={`feature-description-text leading-[17px] mb-0 md:inline-block md:leading-5 md:text-sm text-gray-800 text-[13px] ${
        isFirstRecentPostItem ? "inline-block" : "hidden"
      }`}
      style={
        isDesktopWidth && !isFirstRecentPostItem
          ? getDescriptionStyle(isTwoLines)
          : {}
      }
    >
      {isFirstRecentPostItem
        ? resource.descriptionWithHtml
        : resource.description}
    </Content>
  );
};

export default Description;
